import { FontWeights, IButtonStyles, mergeStyles, mergeStyleSets } from "@fluentui/react";

export const formButtonContainerStyles = mergeStyles([{
    marginTop: '2dvh',
    width: '30dvw',
    height: 'auto',
}]);

export const xxlFormButtonContainerStyles = mergeStyles([{
    marginTop: '1dvh',
    width: '50dvw',
    height: 'auto',
}]);

export const xlFormButtonContainerStyles = mergeStyles([{
    marginTop: '1dvh',
    width: '60dvw',
    height: 'auto',
}]);

export const lgFormButtonContainerStyles = mergeStyles([{
    marginTop: '1dvh',
    width: '60dvw',
    height: 'auto',
}]);

export const mdFormButtonContainerStyles = mergeStyles([{
    marginTop: '1dvh',
    width: '75dvw',
    height: 'auto',
}]);

export const smFormButtonContainerStyles = mergeStyles([{
    marginTop: '5dvh',
    width: '80dvw',
    height: 'auto',
}]);

export const innerTextStyles = mergeStyles([{
    fontSize: '1rem',
    fontWeight: 500,
    fontFamily: 'Nunito',
    textAlign: 'center',
    padding: '2dvh',
}]);

export const innerCreateTenantTextStyles = mergeStyles([{
    fontSize: '.875rem',
    fontWeight: 300,
    fontFamily: 'Nunito',
    textAlign: 'center',
    padding: '1dvh',
}]);

export const xxlInnerCreateTenantTextStyles = mergeStyles([{
    fontSize: 'clamp(0.85rem, 2.5vw, 0.875rem)',
    fontWeight: 300,
    fontFamily: 'Nunito',
    textAlign: 'center',
    padding: '1dvh',
}]);

export const xlInnerCreateTenantTextStyles = mergeStyles([{
    fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
    fontWeight: 300,
    fontFamily: 'Nunito',
    textAlign: 'center',
    padding: '1dvh',
}]);

export const lgInnerCreateTenantTextStyles = mergeStyles([{
    fontSize: 'clamp(0.75rem, 2.5vw, 0.8rem)',
    fontWeight: 300,
    fontFamily: 'Nunito',
    textAlign: 'center',
    padding: '1dvh',
}]);

export const mdInnerCreateTenantTextStyles = mergeStyles([{
    fontSize: 'clamp(0.7rem, 2.5vw, 0.75rem)',
    fontWeight: 300,
    fontFamily: 'Nunito',
    textAlign: 'center',
    padding: '1dvh',
}]);

export const smInnerCreateTenantTextStyles = mergeStyles([{
    fontSize: 'clamp(0.65rem, 2.5vw, 0.7rem)',
    fontWeight: 300,
    fontFamily: 'Nunito',
    textAlign: 'center',
    padding: '1dvh',
}]);

export const innerCreateTenantContainerStyles = mergeStyles([{
    border: '1px solid #323130',
    borderRadius: '5px',
    padding: '3dvh',
    gap: '1dvh',
}]);

export const fallbackMsAccountStyles: IButtonStyles = {
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        color: '#2A7DE1',
        fontSize: '.875rem',
        fontWeight: 500,
        fontFamily: 'Nunito',
        paddingTop: '3dvh'
    },
    textContainer: {
        textAlign: 'left',
    },
    icon: {
        color: '#2A7DE1',
    }
}

export const infoTextStyles = mergeStyles([{
    fontSize: 'clamp(0.7rem, 1.9vw, 0.9rem)',
    fontWeight: 500,
    textAlign: 'left',
    fontFamily: 'Nunito',
    color: '#000000',
}]);

export const infoLinkTextStyles = mergeStyles([{
    fontSize: 'clamp(0.7rem, 1.9vw, 0.9rem)',
    fontWeight: 400,
    textAlign: 'left',
    fontFamily: 'Nunito',
    color: '#2A7DE1',
}]);

export const modalContentStyles = mergeStyleSets({
    container: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch',
    },
    header: {
        flex: '1 1 auto',
        borderTop: `4px solid #2A7DE1`,
        color: '#2A7DE1',
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Nunito',
        fontWeight: FontWeights.semibold,
        padding: '12px 12px 14px 24px',
    },
    heading: {
        color: '#2A7DE1',
        fontFamily: 'Nunito',
        fontWeight: FontWeights.semibold,
        fontSize: 'clamp(1.3rem, 2.5vw, 1.4rem)',
        margin: '0',
    },
    body: {
        flex: '4 4 auto',
        padding: '0 24px 24px 24px',
        overflowY: 'hidden',
        fontFamily: 'Nunito',
        fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
        color: '#323130',
    },
});

export const xxlModalContentStyles = mergeStyleSets({
    container: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch',
    },
    header: {
        flex: '1 1 auto',
        borderTop: `4px solid #2A7DE1`,
        color: '#2A7DE1',
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Nunito',
        fontWeight: FontWeights.semibold,
        padding: '12px 12px 14px 24px',
    },
    heading: {
        color: '#2A7DE1',
        fontFamily: 'Nunito',
        fontWeight: FontWeights.semibold,
        fontSize: 'clamp(1.3rem, 2.5vw, 1.4rem)',
        margin: '0',
    },
    body: {
        flex: '4 4 auto',
        padding: '0 24px 24px 24px',
        overflowY: 'hidden',
        fontFamily: 'Nunito',
        fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
        color: '#323130',
    },
});

export const xlModalContentStyles = mergeStyleSets({
    container: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch',
    },
    header: {
        flex: '1 1 auto',
        borderTop: `4px solid #2A7DE1`,
        color: '#2A7DE1',
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Nunito',
        fontWeight: FontWeights.semibold,
        padding: '12px 12px 14px 24px',
    },
    heading: {
        color: '#2A7DE1',
        fontFamily: 'Nunito',
        fontWeight: FontWeights.semibold,
        fontSize: 'clamp(1.3rem, 2.5vw, 1.4rem)',
        margin: '0',
    },
    body: {
        flex: '4 4 auto',
        padding: '0 24px 24px 24px',
        overflowY: 'hidden',
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.95rem, 2.5vw, 1.1rem)',
        color: '#323130',
    },
});

export const lgModalContentStyles = mergeStyleSets({
    container: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch',
    },
    header: {
        flex: '1 1 auto',
        borderTop: `4px solid #2A7DE1`,
        color: '#2A7DE1',
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Nunito',
        fontWeight: FontWeights.semibold,
        padding: '12px 12px 14px 24px',
    },
    heading: {
        color: '#2A7DE1',
        fontFamily: 'Nunito',
        fontWeight: FontWeights.semibold,
        fontSize: 'clamp(1.3rem, 2.5vw, 1.4rem)',
        margin: '0',
    },
    body: {
        flex: '4 4 auto',
        padding: '0 24px 24px 24px',
        overflowY: 'hidden',
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
        color: '#323130',
    },
});

export const mdModalContentStyles = mergeStyleSets({
    container: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch',
    },
    header: {
        flex: '1 1 auto',
        borderTop: `4px solid #2A7DE1`,
        color: '#2A7DE1',
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Nunito',
        fontWeight: FontWeights.semibold,
        padding: '12px 12px 14px 24px',
    },
    heading: {
        color: '#2A7DE1',
        fontFamily: 'Nunito',
        fontWeight: FontWeights.semibold,
        fontSize: 'clamp(1.3rem, 2.5vw, 1.4rem)',
        margin: '0',
    },
    body: {
        flex: '4 4 auto',
        padding: '0 24px 24px 24px',
        overflowY: 'hidden',
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)',
        color: '#323130',
    },
});

export const smModalContentStyles = mergeStyleSets({
    container: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch',
    },
    header: {
        flex: '1 1 auto',
        borderTop: `4px solid #2A7DE1`,
        color: '#2A7DE1',
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Nunito',
        fontWeight: FontWeights.semibold,
        padding: '12px 12px 14px 24px',
    },
    heading: {
        color: '#2A7DE1',
        fontFamily: 'Nunito',
        fontWeight: FontWeights.semibold,
        fontSize: 'clamp(1.3rem, 2.5vw, 1.4rem)',
        margin: '0',
    },
    body: {
        flex: '4 4 auto',
        padding: '0 24px 24px 24px',
        overflowY: 'hidden',
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)',
        color: '#323130',
    },
});
  
export const modalIconButtonStyles: Partial<IButtonStyles> = {
root: {
    color: '#323130',
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px',
},
rootHovered: {
    color: '#2A7DE1',
},
};